/***********************************************/
// Capa de Servicios para el modulo de Usuarios.

import axios from "axios";
import store from "@/store/store.js";

export default new class {

    #baseUrl = null;
    errormsg = '';
    message = null;
    header = {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
    };

    constructor() {
        this.#baseUrl = store.getters.getBaseURL;
    }

    async getUserCurrent(){
        try{
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(`${this.#baseUrl}/auth/user`, this.header);
            return response.data;
        } catch (error){
            this.handleError(error);
        }
    }

    async getNotificationInvestor(){
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(`${this.#baseUrl}/notifications/investor`, this.header);
            return response.data;
        }catch (error){
            this.handleError(error);
        }
    }

    async getNotificationInvestorNotRead(){
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(`${this.#baseUrl}/notifications/investor/not-read`, this.header);
            return response.data;
        }catch (error){
            this.handleError(error);
        }
    }

    async getNotificationAdmin(){
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(`${this.#baseUrl}/notifications/admin`, this.header);
            return response.data;
        }catch (error){
            this.handleError(error);
        }
    }

    async getNotificationAdminNotRead(){
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(`${this.#baseUrl}/notifications/admin/not-read`, this.header);
            return response.data;
        }catch (error){
            this.handleError(error);
        }
    }

    async sendNotification(obj){
        try{
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            const formData = new FormData();
            formData.append('title', obj.title);
            formData.append('message', obj.message);
            formData.append('investors', JSON.stringify(obj.investors));
            formData.append('file', obj.file);
            let response = await axios.post(`${this.#baseUrl}/notifications/send`, formData, this.header);
            return response.data;
        }catch (error){
            this.handleError(error)
        }
    }

    async readNotification(notification){
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.put(`${this.#baseUrl}/notifications/read/${notification.id}`, {}, this.header);
            return response.data;
        }catch (error){
            this.handleError(error);
        }
    }

    async getAllRecords() {
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(this.#baseUrl + "/view-list/users", this.header);
            // console.log('response: ', response);
            if (response.data.success) {
                // console.log("records:", response.data);
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }
    
    async getViewListInvestors() {
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(this.#baseUrl + "/view-list-investors/users", this.header);
            // console.log('response: ', response);
            if (response.data.success) {
                // console.log("records:", response.data);
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getRecord(id) {
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(`${this.#baseUrl}/users/${id}`, this.header);
            if (response.data.success) {
                // console.log("records:", response.data);
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }
    
    async addRecord(formData, picture_id, imageFile) {
        // console.log('Adding Record.', formData);
        let result = null;
        let recordData = new FormData();
        recordData.append("id", formData.id);
        recordData.append("name", formData.name);
        recordData.append("last_name", formData.last_name);
        recordData.append("email", formData.email);
        recordData.append("password", formData.password);
        recordData.append("roles", formData.roles);
        recordData.append("active", formData.active);
        // console.log('Record-Data: ', recordData);
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.post(this.#baseUrl + "/users", recordData, this.header);
            if (response.data.success) {
                let data = response.data;
                let user_id = data.id;
                this.uploadImage(user_id, picture_id, imageFile);
                result = data;
            } else {
                result = null;
            }
        }  catch (error) {
            result = this.handleError(error);
        }
        return result;
    }

    // Pushes posts to the server when called.
    async updateRecord(formData, picture_id, imageFile) {
        let result = null;
        // console.log('Updating Record: %s %s ', formData.id, formData);
        let recordData = new FormData();
        recordData.append("id", formData.id);
        recordData.append("name", formData.name);
        recordData.append("last_name", formData.last_name);
        recordData.append("email", formData.email);
        recordData.append("password", formData.password);
        recordData.append("roles", formData.roles);
        recordData.append("active", formData.active);
        recordData.append('_method', 'put');
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.post(`${this.#baseUrl}/users/${formData.id}`, recordData, this.header);
            if (response.data.success) {
                let data = response.data;
                let user_id = data.id;
                this.uploadImage(user_id, picture_id, imageFile);
                result = data;
            } else {
                result = null;
            }
        } catch (error) {
            result = this.handleError(error);
        }
        return result;
    }
    
    async deleteRecord(id) {
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.delete(`${this.#baseUrl}/users/${id}`, this.header);
            if (response.data.success) {
                // console.log('Respuesta: ', response.data);
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getQRCodeURL() {
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(`${this.#baseUrl}/qr-user/url`, this.header);
            if (response.data.success) {
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getQRCodeURLById(id) {
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let response = await axios.get(`${this.#baseUrl}/qr-user/url/${id}`, this.header);
            if (response.data.success) {
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }

    async changePassword(user_id, password) {
        try {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let formData = new FormData();
            formData.append("user_id", user_id);
            formData.append("password", password);
            let response = await axios.post(this.#baseUrl + '/change-password/users', formData, this.header);
            if (response.data.success) {
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }

    uploadImage(user_id, picture_id, imageFile) {
        if (imageFile) {
            this.header.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
            let formData = new FormData();
            formData.append("user_id", user_id);
            formData.append("picture_id", picture_id);
            formData.append("file", imageFile);
            axios.post(this.#baseUrl + '/upload-image/users', formData, this.header)
                .then(response => {
                    return response.data;
                    // console.log('Respuesta: ', response.data);
                })
                /* handle error */
                .catch(error => {
                    return this.handleError(error);
                    }
                );
        }
    }

    handleError(error) {
        let valueError;
        if (error.response) {
            valueError = error.response.data.messaje;
        } else if (error.request) {
            valueError = error.request.data;
        } else {
            // Something happened in setting up the request and triggered an Error
            valueError = error.message;
        }
        // console.log(error.config);
        return valueError;
    }
}
